function hasAtLeastOneValue(input) {
  const isNonEmpty = val => val !== null && val !== undefined && val !== '';

  if (Array.isArray(input)) {
    return input.some(item => {
      if (Array.isArray(item) || (item && typeof item === 'object')) {
        return hasAtLeastOneValue(item); // recursive check for nested objects/arrays
      }
      return isNonEmpty(item);
    });
  }

  if (input && typeof input === 'object') {
    return Object.values(input).some(val => {
      if (Array.isArray(val) || (val && typeof val === 'object')) {
        return hasAtLeastOneValue(val); // recursive
      }
      return isNonEmpty(val);
    });
  }

  if (isNonEmpty(input)) {
    return true;
  }

  return false;
}

export default hasAtLeastOneValue;
